import { getFromBreakpoint, getUpToBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	titleWrapper: {
		display: 'flex',
		gap: theme.spacing.xxsmall,
		alignItems: 'center',
		marginBottom: theme.spacing.small,

		[getFromBreakpoint('md')]: {
			gap: theme.spacing.medium,
		},
	},
	roomsContainer: {
		display: 'flex',
		flexDirection: 'column',
	},
	showMoreContainer: {
		marginTop: theme.spacing.small,
	},
	tagWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.xsmall,
		alignItems: 'flex-end',
	},
	roomsContent: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.xsmall,

		[getFromBreakpoint('md')]: {
			flexDirection: 'row',
			alignItems: 'center',
		},
	},
	roomImage: {
		objectFit: 'cover',

		[getUpToBreakpoint('md')]: {
			width: 'auto',
			height: 'auto',
			// 4:3 ratio
			maxHeight: '263px',
			maxWidth: '350px',
		},
	},
}));
